<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { CreditCard } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import EditCreditCard from './EditCreditCard.vue';
    import QueryKey from '@/enums/QueryKey';
    import { usePage } from '@inertiajs/vue3';
    import { computed } from 'vue';
    import type { SharedData } from '@/types';

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    defineProps<{
        creditCard: CreditCard;
    }>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions :data="creditCard">
        <EditCreditCard
            v-if="hasPermission(Permission.CREDIT_CARDS_UPDATE)"
            :credit-card="creditCard"
        />
        <Delete
            v-if="hasPermission(Permission.CREDIT_CARDS_DELETE)"
            :route="
                route('v2.credit-cards.destroy', {
                    company: selectedCompanyId,
                    creditCard: creditCard.id,
                })
            "
            :query-key="[QueryKey.CREDIT_CARDS, selectedCompanyId]"
            header="credit-cards.delete.title"
            description="credit-cards.delete.content"
            success-message="credit-cards.delete.success"
        />
    </DataTableActions>
</template>
